import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'
import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/composedReport/translations/TRANSLATION_KEYS'

import { Translation } from 'cng-common/features/translations/components/translation'
import { getUrlWithParams } from 'core-components/helpers/url'
import { IColumn } from 'core-components/library/list/types'

import { extraColumns as partnerSelectExtraColumns } from '../scopeSection/partnersSelect/configs'

export const extraScopeTableColumns: IColumn[] = [
  ...partnerSelectExtraColumns,
  {
    field: '',
    title: TRANSLATION_KEYS.partner360Link,
    priority: 6,
    renderFunction: (item: IWWPartners) => {
      return (
        <a
          target="_blank"
          href={getUrlWithParams({
            page: 'jbl-hpscoutso',
            pid: encodeURIComponent(String(item.PartnerID)),
            'jbp-tab': 20,
          })}
          rel="noreferrer"
        >
          <Translation text={TRANSLATION_KEYS.openPartner360} />
        </a>
      )
    },
  },
]
